import { Permission } from '@cims-online/shared'
import { simpleSuccessNotification } from 'hooks/notificationHandler'
import { useCreateNonUserEmailMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  NonUserEmail,
  useNonUserEmailsTableContext,
} from '../../../../NonUserEmailsTableContext'
import {
  CreateNonUserEmailModalBody,
  CreateNonUserEmailModalValues,
} from './components/CreateNonUserEmailBody'
import { useProjectContext } from 'context/ProjectContext'

export function useCreateOptions(): CreateHeaderActionOptions<NonUserEmail> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useNonUserEmailsTableContext()
  const [createNonUserEmail, { loading: creating }] =
    useCreateNonUserEmailMutation({
      ...DefaultMutationHookOptions,
      onCompleted: ({
        createNonUserEmail: {
          nonUserEmail: { label, address },
        },
      }) => simpleSuccessNotification(label ?? address),
    })
  return {
    loading: fetching || creating,
    entity: 'Non User Email',
    permission: Permission.CreateNonUserEmail,
    modal: {
      type: 'simple',
      body: <CreateNonUserEmailModalBody />,
      onOk: async ({
        label,
        address,
        description,
      }: CreateNonUserEmailModalValues) => {
        await createNonUserEmail({
          variables: {
            createNonUserEmailInput: {
              projectId,
              label,
              address,
              description,
            },
          },
        })
        refetch()
      },
    },
  }
}
